function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.775 8.515c2.109.82 4.335 1.302 6.595 1.426v1.649h3.297V9.94a23.221 23.221 0 006.595-1.392v6.339H.775V8.515zM11.492.873l.824.824v1.649h4.946V7.64a23.387 23.387 0 01-7.897 1.475H8.77A23.156 23.156 0 01.775 7.6V3.346H5.72V1.697l.824-.824h4.947zm-.825 1.649H7.37v.824h3.297v-.824z",
  fill: "#fff"
});

function SvgIconProjectsSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    fill: "none"
  }, props), _ref);
}

export default SvgIconProjectsSmall;